import getSelectedQuickShadeVariantIdSelector from 'modules/variant/redux/selectors/get-selected-quick-shade-variant-id'

// handle already sampled item CVR

/**
 * @param shouldFlattenSamples
 * @param productVariantImage
 * @param variantId
 * @param {ProductVariantCollection[]} variants
 * @returns {(function(*): (*|undefined))|*}
 */
export default function getImageUrlProductCollectionItemSelector ({
  shouldFlattenSamples,
  productVariantImage,
  variantId,
  variants
}) {
  return (state) => {
    const selectedVariantId = getSelectedQuickShadeVariantIdSelector(variantId)(state)

    /**
     * @type {ProductVariantCollection}
     */
    let productVariant
    if (selectedVariantId && variants?.length) {
      productVariant = variants.find(
        variant => variant.variant_id === selectedVariantId
      )
    }

    let imageUrl
    if (productVariant) {
      imageUrl = productVariant?.variant_image_url
      // imageUrl = getImageToDisplayOnCardSelector({
      //   productVariantSample: productVariant
      // })(state)
    }

    if (imageUrl) {
      return imageUrl
    }

    if (shouldFlattenSamples) {
      return productVariantImage
    }
  }
}
